import classnames from 'classnames';

export default function InputError({ children, className }) {
  return (
    <p className={classnames('mt-2 text-red-600 text-sm', className)}>
      {children}
    </p>
  );
}
